import React from "react";

import styles from "./PointItem.module.scss";

type Props = {
  text: string;
  activeText: string;
  isActive: boolean;
};

const PointItem: React.FC<Props> = ({ text, activeText, isActive }) => {
  return (
    <div
      className={`${styles["f-pointItem"]} ${isActive ? styles["active"] : ""}`}
    >
      {isActive == true ? activeText : text}
    </div>
  );
};

export default PointItem;
